module.exports = __webpack_public_path__ + "img/asset_mSOL.61c81b4f.svg";